<script>
import { mapGetters } from "vuex";
import { GETNOTIFICATION ,GETVERSION,GETTOKEN} from "../SystemFuns";

export default {
  computed: {
    ...mapGetters("app", ["phoneModel", "isHOM", "isAndroid", "isIOS"])
  },
  mounted() {
    // 提醒
    window.getYGJNotificationResult = this.getYGJNotificationResult; //安卓ios 创建日历回调
    if (window.webkit) {
      window.webkit.messageHandlers.getYGJNotificationResult.onmessage = this.getYGJNotificationResult; // 本地提醒列表
    }
  },
  methods: {
    getSystemReminder() {
      GETNOTIFICATION();
    },
    getSysVersion(){
      GETVERSION()
    },
    /**
     *
     * @param {Array} result
     */
    getYGJNotificationResult(result) {
      console.log(result,'getYGJNotificationResult');
      if(result.type==2){
        this.handleGetVersionResult(result);//获取版本
      }else {
        this.handleGetNotificationResult(result);//药管家提醒列表
      }

    },
  }
};
</script>



// WEBPACK FOOTER //
// src/systemFolder/mixins/getSystemReminder.vue